import React, { useState, useEffect } from 'react'
import UserProfile from '../../components/UserProfile'
import VendorBarChart from '../../components/vendor/VendorBarChart'
import VendorPieChart from '../../components/vendor/VendorPieChart'
import VendorTableView from '../../components/vendor/VendorTableView'
import VendorTotalPO from './VendorTotalPO'
import VendorCRage from '../../components/vendor/VendorCRage'
import SelectVendor from '../../components/vendor/SelectVendor'
import { CartState } from '../../Context/Context'
import MaintenanceBanner from '../../components/MaintenenceBanner';
import { getBanners } from '../../utils/Utils'

const VendorDashboard = () => {
  const user = JSON.parse(localStorage?.getItem('userData'))
  const vendorIdSelected = user?.supplierId
  const [showSelectVendorModal, setShow] = useState(false)
  const [showBanner, setShowBanner] = useState(true);
  const [bannerData, setbannerData] = useState([])

  const {
    getNotificationCountForBuyer,
    getNotificationListForBuyer,
    getNotificationcountForSupplier,
    getNotificationListForSupplier
  } = CartState()

  const fetchNotifications = () => {
    if (user?.userGroupName !== 'OVERSEAS_ROLE') {
      if (user?.roleName === 'BUYER_ROLE') {
        getNotificationCountForBuyer(user?.email)
        getNotificationListForBuyer(user?.email)
      } else if (user?.roleName === 'SUPPLIER_ROLE') {
        getNotificationcountForSupplier(user?.supplierId)
        getNotificationListForSupplier(user?.supplierId)
      }
    }
  }

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("userDataArray"))?.length > 1 && !user) setShow(true)
  })

  useEffect(() => {
    fetchNotifications();
  }, []);
  
    const fetchData = async () => {
      try {
        const data = await getBanners(); 
        setbannerData(data);
      } catch (err) {
        console.error(err,"err")
      }
    };
    
  useEffect(() => {
    const isBannerClosed = sessionStorage.getItem('hasClosedBanner');
   
    if (!isBannerClosed && vendorIdSelected) {
      fetchData();
    }
  }, [vendorIdSelected]);

  useEffect(() => {
    if (bannerData && bannerData.length > 0) {
      setShowBanner(true);
    }
  }, [bannerData]); 

  return (
    <div className='w-full flex flex-col gap-4 '>
      {localStorage?.getItem('userData') && <>
        <div className='w-full flex justify-end items-center'>
          {/* <UserProfile /> */}
        </div>
        {showBanner && 
        <MaintenanceBanner bannerData={bannerData} setShowBanner={setShowBanner} setbannerData={setbannerData}/>}
        <div className='w-full flex gap-5 justify-center flex-col lg:flex-row'>
          <VendorBarChart supplierId={vendorIdSelected} />
          <VendorPieChart supplierId={vendorIdSelected} />
        </div>
        <div className='w-full overflow-x-auto flex flex-col justify-center items-center gap-5 '>
          <div className='w-full flex gap-3 justify-center items-center min-w-max'>
            <VendorTableView supplierId={vendorIdSelected} />
          </div>
        </div>
        <div>
          <VendorCRage supplierId={vendorIdSelected} />
        </div>
        <div>
          <VendorTotalPO supplierId={vendorIdSelected} />
        </div>
      </>}
      <SelectVendor isOpen={showSelectVendorModal} onCancel={() => setShow(false)} />
    </div>
  )
}

export default VendorDashboard
